import {FETCH_LOGS_BY_PALLET_IDENTIFIERS} from "@/store/actions.type";
import {PalletService} from "@/common/api";
import {SET_PALLET_LOGS} from "@/store/mutations.type";

const state = {
	pallet: null,
	palletLogs: null
};

const getters = {
	pallet: state => state.pallet,
	palletLogs: state => state.palletLogs
};

const actions = {
	async [FETCH_LOGS_BY_PALLET_IDENTIFIERS]({commit}, identifiers) {
		return PalletService.getLogsByPalletIdentifiers(identifiers)
			.then(({data}) => {
				commit(SET_PALLET_LOGS, data);
				return data;
			})
			.catch(error => {
				throw new Error(error);
			});
	}
};

const mutations = {
	[SET_PALLET_LOGS](state, logs) {
		state.palletLogs = logs;
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};